export enum SignUpSteps {
  CreateMember,
  SignUpSeed,
  SignUpEmail,
  SignUpPassword,
  Creating,
  Success,
}
